<script setup>
    import { reactive, ref, computed } from 'vue'

    const emit = defineEmits(['goConfirm', 'close'])

    const props = defineProps({
        formData: Object
    })
    
    // 登録ユーザー情報
    const reactiveObj = reactive({
        userId: props.formData?.userId ?? '',
        userName: props.formData?.userName ?? '',
        img: props.formData?.img ?? '',
        previewImg: props.formData?.previewImg ?? ''
    })

    // 顔画像プレビュー
    const previewRef = ref(null)

    const userInfos = ref(
        props.formData?.userInfos ?? [
            { name: '', content:'', placeholder1: 'メールアドレス', placeholder2: 'example@example.com'}
    ])

    // 実行ボタンの活性/非活性化
    const isValid = computed(() => {
        return reactiveObj.userId && reactiveObj.userName && reactiveObj.img
    })
    // 項目欄 追加
    const addUserInfo = () => {
        let form_body = {
            name: '', content:'', placeholder1: '入力してください', placeholder2: '入力してください'
        }
        userInfos.value.push(form_body);
    }
    // 項目欄 削除
    const deleteUserInfo = (index) => {
        userInfos.value.splice(index, 1);
    }

    // ファイル取得
    const setImageFile = (file) => {
        if (!file) return

        // JPG/JPEG、PNG、WEBPのみ許可
        const validTypes = [
            'image/jpeg',
            'image/png',
            'image/jpg',
            'image/webp'
        ]
        if (!validTypes.includes(file.type)) {
            alert('JPG、PNG、WEBP形式の画像を選択してください。');
            return;
        }

        reactiveObj.img = file
        reactiveObj.previewImg = URL.createObjectURL(file)
    }
    // ファイル選択時の処理
    const uploadFile = (event) => {
        const file = event.target.files?.[0]
        setImageFile(file)
    }
    // ファイルドロップ時の処理
    const dropFile = (event) => {
        event.preventDefault()
        const file = event.dataTransfer?.files?.[0]
        setImageFile(file)
    }
    // ドラッグ中
    const dragOver = (event) => {
        event.preventDefault()
    }

    // ユーザー情報登録確認画面へ
    const goConfirm = () => {
        emit('goConfirm', {
            userId: reactiveObj.userId,
            userName: reactiveObj.userName,
            img: reactiveObj.img,
            previewImg: reactiveObj.previewImg,
            userInfos: userInfos.value
        })

    }
    // ユーザー登録画面クローズ
    const closeRegist = () => {
        emit('close')
    }

</script>
<template>
    <div class="mainView">
        <nav class="breadcrumb">
            <span class="breadcrumb-sub" @click="closeRegist">利用者管理 </span>
            <span> &gt; </span>
            <span class="breadcrumb-main"> 利用者新規登録</span>
        </nav>
        <div class="titleArea">
            <p class="title">利用者新規登録</p>
            <div class="titleTextArea">
                <p class="titleText">新しい利用者を登録します。ユーザー情報と顔画像を登録してください。</p>
            </div>
        </div>
        <div class="userRegistArea">
            <div class="inputUserInfoArea">
                <p class="registUserTitle" ><span class="fontColorPk">① </span>基本情報</p>
                <div class="formRow">
                    <p class="label">ユーザーID <span class="requireView">必須</span></p>
                    <div class="inputArea">
                        <input type="text" placeholder="例) user-0001" v-model="reactiveObj.userId">
                        <p class="note">半角英数字、ハイフン（-）、アンダースコア（_）が使用できます。</p>
                    </div>
                </div>
                <div class="formRow">
                    <p class="label">ユーザー名 <span class="requireView">必須</span></p>
                    <div class="inputArea">
                        <input type="text" placeholder="例) 山田 太郎" v-model="reactiveObj.userName">
                        <p class="note">ユーザーの氏名または表示名を入力してください。</p>
                    </div>
                </div>
                <table class="userInfoTable">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>内容</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(userInfo, index) in userInfos" :key="index">
                            <td>
                                <input class="inputUsrInfo" v-model="userInfo.name" :placeholder="userInfo.placeholder1">
                            </td>
                            <td>
                                <input class="inputUsrInfo" v-model="userInfo.content" :placeholder="userInfo.placeholder2">
                            </td>
                            <td>
                                <button class="deleteButton" @click="deleteUserInfo(index)"><img src="../assets/usermng_delete.png" class="deleteIcon"></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div id="addUserArea">
                    <button class="exeButton textLeft" @click="addUserInfo()">＋ 項目を追加</button>
                </div>
                <p class="textLeft note">※ 上記は任意項目です。必要に応じて項目を追加してください。</p>
            </div>
            <div class="inputUserImgArea">
                <p class="registUserTitle" ><span class="fontColorPk">② </span>顔画像登録</p>
                    <div class="imgUploadRow">
                        <p class="label">顔画像 <span class="requireView">必須</span></p>
                        <div class="inputUserImg">
                            <div class="inputImg">
                                <input type="file" ref="previewRef" @change="uploadFile" accept=".jpg,.jpeg,.png,.webp" hidden>
                                <div class="dropArea" @click="previewRef.click()" @dragover.prevent="dragOver" @drop.prevent="dropFile">
                                    <div class="dropInner">
                                        <img src="../assets/userregist_img.png">
                                        <p class="mainText">画像をアップロードしてください</p>
                                        <p class="subText">またはドラッグ＆ドロップ</p>
                                        <button type="button" class="exeButton">ファイルを選択</button>
                                    </div>
                                </div>
                            </div>
                            <p class="textLeft note">・登録可能なファイル形式：JPG、PNG、WEBP</p>
                            <p class="textLeft note">・推奨サイズ：640×640px 以上</p>
                            <p class="textLeft note">・正面を向いた、はっきりと顔が映っている画像を登録してください。</p>
                        </div>
                        <div class="previewUserImg">
                            <div class="preview">
                                <p class="previewTitle">プレビュー</p>
                                <div class="previewBox">
                                    <img :src="reactiveObj.previewImg || require('../assets/userregist_img.png')">
                                </div>
                            </div>
                            <p class="subText">※ プレビューは選択後に表示されます</p>
                        </div>
                    </div>
            </div>
            
        </div>
        <div class="userRegistButtonArea">
            <button type="button" class="clearButton" @click="closeRegist">キャンセル</button>
            <button type="button" class="nextButton" @click="goConfirm" :disabled="!isValid">確認画面へ</button>
        </div>
    </div>
</template>

<style scoped>
    .breadcrumb{
        align-items: left;
        text-align: left;
        padding-top:15px;
        padding-left:20px;
    }
    .breadcrumb-sub{
        font-size: 18px;
        margin: 0 10px;
        cursor:pointer;
    }
    .breadcrumb-main{
        font-size: 18px;
        margin: 0 10px;
        font-weight: bold;
    }
    .userRegistArea {
        width:95%;
        margin:0 auto;
        border-radius: 10px;
        border: 1px solid #e0e0e0;
        padding:20px;
    }
    .inputUserInfoArea{
        width:100%;
        border-bottom: 1px solid #cecbcb;
        padding:15px;
        box-sizing:border-box;
    }
    .registUserTitle {
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        padding:10px;
    }
    .formRow {
        display: flex;
        align-items: flex-start;
        gap: 20px;
        margin-bottom: 20px;
    }
    .inputArea {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
    }
    .inputArea input {
        width: 90%;
        padding: 8px;
        border-radius: 10px;
        margin:0 10px;
        height:40px;
    }
    .note {
        font-size: 15px;
        color: #777;
        margin-top: 5px;
    }
    .label {
        width: 150px;
        text-align: right;
        margin-top: 8px;
        font-weight: bold;
        padding:10px;
        display: flex;
        white-space: nowrap;
    }
    
    .userInfoTable {
        width: 100%;
        border-collapse: separate;
    }
    .userInfoTable thead th {
        background: #eae6e7;
        padding: 12px;
        text-align: left;
        font-weight: bold;
    }
    .userInfoTable tbody tr {
        background: #fff;
        border-radius: 8px;
        margin-bottom: 10px;
    }
    .userInfoTable td:last-child {
        display: flex;
        text-align: center;
        vertical-align: middle; 
    }
    .userInfoTable tbody td {
        padding: 10px 15px;
        vertical-align: middle;
    }

    .userInfoTable thead tr th:first-child {
        border-top-left-radius: 8px;
    }
    .userInfoTable thead tr th:last-child {
        border-top-right-radius: 8px;
    }
    #addUserArea{
        border-radius: 10px;
        border: 1px solid #e0e0e0;
        background-color: white;
        padding:10px;
        text-align: left;
        margin: 10px 0 10px 0;
    }
    
    .imgUploadRow {
        display: flex;
        gap: 20px;
        align-items: flex-start;
        width: 100%;
    }

    .inputUserImgArea {
        display: block;
        gap: 40px;
        justify-content: left;
        margin-top: 20px;
    }
    
    .imgContentArea {
        display: block;
        align-items: flex-start;
        gap: 30px;
    }

    .inputUserImg {
        width: 45%;
        padding:10px;
    }
    .inputImg{
        border-radius: 10px;
        border: 2px dotted gray;
        padding:40px;
    }
    .mainText{
        font-size: 18px;
        font-weight: bold;
    }
    .subText{
        font-size: 15px;
        color: #777;
        margin:5px;
    }
    
    .previewUserImg {
        width: 300px;
        text-align: center;
        
    }
    .preview{
        border-radius: 10px;
        border: 1px solid #e0e0e0;
        padding:20px;
        margin-top:10px;
    }
    .previewUserImg img {
        width: 100%;
        border-radius: 8px;
    }
    
    .previewUserImg {
        width: 240px;
    }
    
    .previewTitle {
        font-weight: bold;
        margin-bottom: 10px;
        text-align:left;
    }

    .previewBox {
        width: 100%;
        height: 200px;
        background: #f3f3f3;
        border-radius: 10px;
        border: 1px solid #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .previewBox img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .userRegistButtonArea {
        display: flex;
        justify-content: center;
        margin:20px;
        gap:20px;
    }
    
    .inputUsrInfo {
        width: 90%;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 6px;
        text-align: left;
    }
    .deleteButton {
        width: 45px;
        height: 45px;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .deleteIcon{
        width:30px;
        height: 30px;
        
    }

    @media (max-width: 1024px) {
        .userRegistArea {
            width: 100%;
            margin: 0 auto;
            padding: 16px;
        }
        .formRow {
            flex-wrap: wrap;
            gap: 12px;
        }
        .label {
            width: 100%;
            text-align: left;
            margin-top: 0;
            padding: 0 10px 0 0;
        }
        .inputArea input {
            width: 100%;
            margin: 0;
        }
        .imgUploadRow {
            flex-direction: column;
        }
        .inputUserImg,
        .previewUserImg {
            width: 100%;
        }
        .inputImg {
            padding: 24px;
        }
        .previewBox {
            min-height: 180px;
        }
        .userRegistButtonArea {
            flex-direction: column;
        }
        .exeButton,
        .clearButton {
            width: 100%;
        }
    }

    @media (max-width: 768px) {
        *, *::before, *::after {
            box-sizing: border-box;
        }
        .breadcrumb{
            margin-top: 15px;
            padding:10px;
            font-size:14px;
        }
        .breadcrumb-sub, .breadcrumb-main{
            font-size:16px;
            margin:0 3px;
        }
        .userRegistArea {
            padding:10px;
            margin:0;
        }
        .inputArea, .inputUserInfoArea, .inputUserImgArea, .formRow{
            min-width:0;
        }
        .inputUserImg,
        .previewUserImg {
            width: 100%;
        }
        .previewBox{
            height:160px;
        }
        .inputImg {
            padding:25px 15px;
        }
        .dropInner img{
            width:70px;
        }
        .formRow {
            flex-direction:column;
            gap:5px;
        }
        .inputArea input {
            width:100%;
            margin:0;
            box-sizing:border-box;
        }
        .imgUploadRow{
            flex-direction:column;
        }
        .label{
            width:100%;
            text-align:left;
            display:flex;
            align-items:center;
            gap:8px;
            margin-bottom:8px;
            font-size:16px;
        }
        .note{
            font-size:13px;
            line-height:1.6;
        }
        .inputUserImg{
            width:100%;
            box-sizing:border-box;
        }
        .inputArea input{
            width:100%;
            margin:0;
            box-sizing:border-box;
        }
        .userInfoTable, .userInfoTable tbody, .userInfoTable tr,.userInfoTable td{
            display:block;
            width:100%;
        }
        .userInfoTable thead{
            display:none;
        }
        .userRegistButtonArea{
            flex-direction:column;
        }
        .userRegistButtonArea button{
            width:100%;
            height:48px;
            font-size:16px;
        }
    }
</style>